import * as Sentry from "@sentry/vue";
import { AxiosError, InternalAxiosRequestConfig } from "axios";

import { getAuthClient } from "@/modules/authorisation/authClient";

export async function onRequestSuccess(config: InternalAxiosRequestConfig) {
  try {
    const authClient = await getAuthClient();
    const token = await authClient.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      Sentry.captureException("No token present after getAccessToken", {
        contexts: {
          token_request: {
            timestamp: new Date().toISOString(),
          },
        },
      });
    }
    return config;
  } catch (e) {
    const authClient = await getAuthClient();
    Sentry.captureException(e, {
      contexts: {
        token_request: {
          timestamp: new Date().toISOString(),
        },
      },
    });
    await authClient.login();
    throw e;
  }
}

export function onRequestFailed(error: AxiosError) {
  return Promise.reject(error);
}
